<template><section><h2>select</h2>
<demo-block>
                  <div slot="source"><template>
  <weui-form :title="'原生选择框'">
    <weui-form-control>
      <weui-form-group>
        <weui-select :name="'type'" v-model="type" @input="show('type')">
          <weui-option value="1" label="微信号"></weui-option>
          <weui-option value="2" label="QQ号"></weui-option>
          <weui-option value="3" label="Email"></weui-option>
        </weui-select>
        <weui-select-group>
          <template #header>
            <select class="weui-select" name="select2">
              <option value="1">+86</option>
              <option value="2">+80</option>
              <option value="3">+84</option>
              <option value="4">+87</option>
            </select>
          </template>
          <template #body>
            <input class="weui-input" type="number" pattern="[0-9]*" placeholder="请输入号码" value="12345678907">
          </template>
        </weui-select-group>
        <weui-select :name="'country'" :label="'国家'" v-model="country" @input="show('country')">
          <weui-option value="1" label="中国"></weui-option>
          <weui-option value="2" label="美国"></weui-option>
          <weui-option value="3" label="英国"></weui-option>
        </weui-select>
      </weui-form-group>
    </weui-form-control>
  </weui-form>
</template>

</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;weui-form :title=&quot;'原生选择框'&quot;&gt;
    &lt;weui-form-control&gt;
      &lt;weui-form-group&gt;
        &lt;weui-select :name=&quot;'type'&quot; v-model=&quot;type&quot; @input=&quot;show('type')&quot;&gt;
          &lt;weui-option value=&quot;1&quot; label=&quot;微信号&quot;&gt;&lt;/weui-option&gt;
          &lt;weui-option value=&quot;2&quot; label=&quot;QQ号&quot;&gt;&lt;/weui-option&gt;
          &lt;weui-option value=&quot;3&quot; label=&quot;Email&quot;&gt;&lt;/weui-option&gt;
        &lt;/weui-select&gt;
        &lt;weui-select-group&gt;
          &lt;template #header&gt;
            &lt;select class=&quot;weui-select&quot; name=&quot;select2&quot;&gt;
              &lt;option value=&quot;1&quot;&gt;+86&lt;/option&gt;
              &lt;option value=&quot;2&quot;&gt;+80&lt;/option&gt;
              &lt;option value=&quot;3&quot;&gt;+84&lt;/option&gt;
              &lt;option value=&quot;4&quot;&gt;+87&lt;/option&gt;
            &lt;/select&gt;
          &lt;/template&gt;
          &lt;template #body&gt;
            &lt;input
              class=&quot;weui-input&quot;
              type=&quot;number&quot;
              pattern=&quot;[0-9]*&quot;
              placeholder=&quot;请输入号码&quot;
              value=&quot;12345678907&quot;
            /&gt;
          &lt;/template&gt;
        &lt;/weui-select-group&gt;
        &lt;weui-select :name=&quot;'country'&quot; :label=&quot;'国家'&quot; v-model=&quot;country&quot; @input=&quot;show('country')&quot;&gt;
          &lt;weui-option value=&quot;1&quot; label=&quot;中国&quot;&gt;&lt;/weui-option&gt;
          &lt;weui-option value=&quot;2&quot; label=&quot;美国&quot;&gt;&lt;/weui-option&gt;
          &lt;weui-option value=&quot;3&quot; label=&quot;英国&quot;&gt;&lt;/weui-option&gt;
        &lt;/weui-select&gt;
      &lt;/weui-form-group&gt;
    &lt;/weui-form-control&gt;
  &lt;/weui-form&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        type: '2',
        country: '3'
      }
    },
    methods: {
      show: function(key) {
        console.log(this[key])
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2>Attributes</h2>
<h3>select</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td>下拉列表的名称</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>label</td>
<td>标签名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>value(v-model)</td>
<td>当前选中的值</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>option</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>label</td>
<td>标签名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>value</td>
<td>选项的值</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>select-group</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>label</td>
<td>标签名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>body</td>
<td>中间区域内容</td>
<td>string / slot</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>isPicker</td>
<td>是否包含模拟选择框(picker)</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>placement</td>
<td>select所在位置</td>
<td>string</td>
<td>before / after</td>
<td>—</td>
</tr>
<tr>
<td>header</td>
<td>右边区域内容</td>
<td>slot</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>showHeader</td>
<td>是否显示右边区域</td>
<td>boolean</td>
<td>—</td>
<td>true</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  export default {
    data() {
      return {
        type: '2',
        country: '3'
      }
    },
    methods: {
      show: function(key) {
        console.log(this[key])
      }
    }
  }
</script>